// extracted by mini-css-extract-plugin
module.exports = {"collapsed":"Collapse_collapsed__2bf4D","show":"Collapse_show__3M91G","collapsing":"Collapse_collapsing__1oiig"};